module.exports = __webpack_public_path__ + "static/media/image-gallery-6.f0aad209.jpg";